import React, { useRef } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Button } from '@mui/material';
import css from './ApplicationForm.module.css';

const ImageUpload = ({ value = [], onChange, maxFiles = 4, onImageClick, readOnly }) => {
  const fileInputRef = useRef();

  const handleAddClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    const newFiles = [...value, ...files].slice(0, maxFiles);
    onChange(newFiles);
    e.target.value = '';
  };

  const handleRemove = (idx) => {
    const newFiles = value.filter((_, i) => i !== idx);
    onChange(newFiles);
  };

  return (
    <div className={css.petPhotoUploadSection}>
      <div className={css.petPhotoPreviewRow}>
        {value.map((file, idx) => {
          const isFileObject = file instanceof File;
          const url = isFileObject ? URL.createObjectURL(file) : file;
          return (
            <div 
              key={idx} 
              className={css.petPhotoPreviewRect} 
              onClick={() => onImageClick(url)}
            >
              <img src={url} alt={`Pet ${idx + 1}`} className={css.petPhotoPreviewImg} />
              {!readOnly && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemove(idx);
                  }}
                  className={css.removePetPhotoBtn}
                >
                  ×
                </button>
              )}
            </div>
          );
        })}
        {!readOnly && value.length < maxFiles && (
          <div className={css.petPhotoPreviewRect} style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'column', cursor: 'pointer' }}>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              style={{ display: 'none' }}
              onChange={handleFileChange}
              disabled={value.length >= maxFiles || readOnly}
            />
            <Button
              type="button"
              variant="contained"
              onClick={handleAddClick}
              disabled={value.length >= maxFiles || readOnly}
              className={css.addPetBtn}
              startIcon={<span className={css.addPetBtnIcon}>+</span>}
            >
              <FormattedMessage
                id="ApplicationForm.addPhoto"
                defaultMessage="Add Photo"
              />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload; 